export default {
    init() {
        $(document).ready(function(){
            $(".sml-owl-text").owlCarousel({
              margin: 0,
              center: false,
              loop: false,
              dots: true,
              mouseDrag: false,
              touchDrag: false,
              pullDrag: false,
              responsive:{
                 0:{
                   items:1
                 }
               }
            });
          
            $(".sml-owl-nav").owlCarousel({
              margin: 0,
              center: true,
              loop: true,
              dots: false,
              nav: true,
              mouseDrag: false,
              touchDrag: false,
              pullDrag: false,
              responsive:{
                 0:{
                   items:3
                 }
               }
            });
          
            $('.sml-owl-nav').on('mousewheel', function(e){
                if(e.originalEvent.wheelDelta /120 > 0) {
                  $(this).trigger('next.owl.carousel', 300);
          
                    let number = $(this).find('.center').children().data('number') - 1;
                    $('.sml-owl-text').trigger('to.owl.carousel', [number, 0, true] );
                    return false;
                }
                else{
                  $(this).trigger('prev.owl.carousel', 300);
          
                    let number = $(this).find('.center').children().data('number') - 1;
                    $('.sml-owl-text').trigger('to.owl.carousel', [number, 0, true] );
                    return false;
                }
            });
          
            $('.prev-btn').on('click', function() {
              $('.sml-owl-nav').trigger('prev.owl.carousel', [300]);
              let number = $(this).parent().find('.center').children().data('number') -1;
                $('.sml-owl-text').trigger('to.owl.carousel', [number, 0, true]);
            });
            $('.next-btn').on('click', function() {
              $('.sml-owl-nav').trigger('next.owl.carousel', [300]);
              let number = $(this).parent().find('.center').children().data('number') -1;
              $('.sml-owl-text').trigger('to.owl.carousel', [number, 0, true]);
            });
          });
          
          
    },
  };